// extracted by mini-css-extract-plugin
export default {"badge":"agentHierarchyStatusBadge_badge__c3t8n","active":"agentHierarchyStatusBadge_active__f9WXu","inactive":"agentHierarchyStatusBadge_inactive__ccb9P"};